export const formatNumber = (value: any = 0) => {
  if (!value) {
    return '0';
  }
  return String(value).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
};
